import * as React from 'react'

import CardGrid from '../../components/CardGrid'

import * as style from './style.module.css'

export interface ApisProps {
}

export class Apis extends React.Component<ApisProps, {}> {
  render() {
    return (
      <div className={style.grid}>
        <CardGrid />
      </div>
    )
  }
}
